'use es6';

import { useSelector } from 'react-redux';
import { getTrackingParams } from '../../selectors/trackingParams';
import { useShortlinkParams as useCoreShortlinkParams } from 'ecosystem-marketplace-core/hooks/useShortlinkParams';

const useShortlinkParams = () => {
  const trackingParams = useSelector(getTrackingParams);
  return useCoreShortlinkParams(trackingParams);
};

export default useShortlinkParams;